import React from 'react';  
import TicketHome from './TicketHome';
import TicketHeader from './TicketHeader';
import TicketInfo from './TicketInfo';
import TicketTasks from './TicketTasks';
import TicketTopPane from './TicketTopPane';
import styles from './Ticket.module.css';

const TicketView = (props) => {
    const {
        active,
        ticket,
        ticketDirty,
        utility,

        //Home tab props
        pole,
        activePoleDirty,
        changePoleText,
        changeSubStationText,
        changeCurcuitText,
        changeLineText,
        jobNumber,
        needsMerge,
        mergeRequired,
        mergeTickets,
        selectedTab,
        closeTicketWindow,
        showStationSelections,
        showSavePoleChanges,
        savePole,
        addPole,
        addPoleError,
        saving,
        arcRatingChange,
        secondaryVoltageChange,
        primaryVoltageChange,
        latitudeChange,
        longitudeChange,
        handleSelectAccessType,
        getSpecificPole,
        handleSelectTicketTab,
        specHintData,
        setSpecText,
        specText,
        potentialPoles,
        changePoleOnTicket,
        sortPoles,
        setPoleSort,
        sortPoleAsc, 
        setSortPoleAsc,
        utilsForDropdown,
        handleTicketSelectUtility,
        job,
        resetPoleId,
        changePoleId,
        changeLineId,
        changeDueDate,

        //Ticket Info Properties
        handleAmbMeetup,
        handleEhasp,
        handleDigDrop,
        handleNRADrop,
        changeRadio,
        handlePermitDrop,
        addPermit,
        changePermitType,
        updateTicketNote,
        handleDeleteWoChip,
        handleAddWoChip,
        activeWorkingNote,
        addNote,
        toggleAddNote,
        updateWorkingNote,
        loadingPermitDnD,
        loadingDigSafeDnD,
        loadingNRADnD,
        digsafe,
        nra,
        ehasp,
        permit_0,
        handleFileSelectClick,
        handleDigFileSelectClick,
        handleNraFileSelectClick,
        handlePermitFileSelectClick,
        handleDigSafeFileUpload,
        handleNRAFileUpload,
        handlePermitFileUpload,
        removeFile,
        workingForemenForDropdown,
        handleWorkingForemanChange,
        handleImageDeleted,


        //Ticket Tasks Properties
        // serviceTasks,
        updateTicketDescription,
        // expandTaskSection,
        // expandedTaskSections,
        // taskChecked,
        tasksChanged

    } = props;

    const handleDueDateChange = (newDueDate) => {
        if (changeDueDate) {
            changeDueDate(newDueDate);
        }
    };

    async function handleDeleteTicket() {
        const confirmed = window.confirm('Are you sure you want to delete this ticket?');
        if (!confirmed) {
          return;
        }
      
        try {
          const response = await fetch(`/api/v1/tickets/${ticket.id}`, {
            method: 'DELETE',
          });
          const data = await response.json();
          if (data.success) {
            //closeTicketWindow();
            window.location.reload();
          } else {
            throw new Error('Failed to delete ticket');
          }
        } catch (error) {
          console.error(error);
        }
      }

    // Helper to check if all required fields are filled
    function allRequiredFieldsFilled(ticket) {
        return (
            ticket &&
            ticket.pole &&
            ticket.pole.pole_name &&
            ticket.pole.line_name &&
            ticket.pole.utility_id_owning_pole &&
            ticket.pole.utility_id_owning_pole !== -1 &&
            ticket.pole.utility_id_owning_pole !== "" &&
            ticket.pole.utility_id_owning_pole !== null &&
            ticket.pole.utility_id_owning_pole !== undefined
        );
    }
    function isNewTicket(ticket) {
        return ticket && ticket.id && ticket.justCreated;
    }
    const isNew = isNewTicket(ticket);
    const requiredFilled = allRequiredFieldsFilled(ticket);
    const saveEnabled = (isNew && requiredFilled) || ticketDirty;

    return (
        <div className={`container-fluid ${active ? 'modal display-block show' : 'modal display-none fade'}`}>

            <div
                className={" popup modalContain"}
                id="createTicketModal"
                tabIndex="-1"
                role="dialog"
                aria-modal="true"
                aria-labelledby="createTicketModalLabel"
                aria-hidden="false"
            >
                <div
                    className={`modal-dialog modal-lg modal-dialog-scrollable modalDialog`}
                    role="document"
                >
                    <div className={`modal-content modalContent`}>
                      {activeWorkingNote &&
                        <div className={styles.notesModalContain}></div>
                      }

                        <TicketHeader
                            mergeRequired={mergeRequired}
                            handleSelectTicketTab={handleSelectTicketTab}
                            selectedTab={selectedTab}
                            closeTicketWindow={closeTicketWindow}
                            editTicket={ticket!==null && ticket!==undefined}
                            saving={saving}
                            poleIssue={needsMerge || !pole || !pole.id}
                        />
                        <TicketTopPane
                            ticket={ticket}
                            jobNumber={jobNumber}
                            utility={utility}
                            closeTicketWindow={closeTicketWindow}
                            handleDeleteTicket={handleDeleteTicket}
                        />
                        <div style={{zIndex: '2000', position: 'absolute', top: '0', left: '0', width:'100%', height: '100%', display: saving ? 'block' : 'none', textAlign: 'center', paddingTop: '5px'}}>
                            
                            <div style={{zIndex: '2', position: 'relative'}}>
                              <svg style={{animationName: 'spin', animationDuration: '1000ms', animationIterationCount: 'infinite', animationTimingFunction: 'linear' }} width="100" height="100" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg" ><path fillRule="evenodd" clipRule="evenodd" d="M117.236 117.564L135.488 51.7447C92.1144 58.0338 57.8376 92.408 51.6958 135.829L27.8827 142.432C31.5571 80.9652 80.6763 31.7417 142.099 27.9031L149.836 0L149.836 27.6621V50.7138L149.836 149.836L150 150L182.436 117.564L247.963 135.734C241.785 92.3581 207.526 58.0292 164.185 51.7447L157.574 27.9031C218.965 31.7398 268.066 80.9159 271.784 142.34L300 150.164L150.164 150.164L182.436 182.436L164.279 247.914C207.349 241.626 241.429 207.643 247.863 164.621L271.742 158C267.712 219.081 218.792 267.897 157.666 271.763L149.836 300L149.836 272.01V248.959L149.836 150.491L117.564 182.764L51.7948 164.526C58.1928 207.593 92.292 241.622 135.393 247.914L142.006 271.763C80.8492 267.895 31.9107 219.032 27.9244 157.907L0 150.164L27.6625 150.164H50.7143L149.836 150.164L117.236 117.564Z" fill="#FFCC18"></path></svg>
                            </div>
                            <div style={{background: 'black', opacity: '.6', width: '100%', height: '100%', position: 'absolute', top: '0', left: '0', zIndex: '1'}}></div>
                          </div>
                        <div className="modal-body modalBody full">

                            <div className="tab-content" id="nav-tabContent" style={{ width: '100%' }}>
                                <TicketHome
                                    active={selectedTab === 'home'}
                                    jobNumber={jobNumber}
                                    ticket={ticket}
                                    pole={pole}
                                    saving={saving}
                                    activePoleDirty={activePoleDirty}
                                    needsMerge={needsMerge}
                                    mergeTickets={mergeTickets}
                                    changePoleText={changePoleText}
                                    changeLineText={changeLineText}
                                    changeSubStationText={changeSubStationText}
                                    changeCurcuitText={changeCurcuitText}
                                    showStationSelections={showStationSelections}
                                    accessTypesForDropdown={props.accessTypesForDropdown}
                                    showSavePoleChanges={showSavePoleChanges}
                                    savePole={savePole}
                                    addPole={addPole}
                                    addPoleError={addPoleError}
                                    changePoleAddress={props.changePoleAddress}
                                    subStations={props.subStations}
                                    arcRatingChange={arcRatingChange}
                                    secondaryVoltageChange={secondaryVoltageChange}
                                    primaryVoltageChange={primaryVoltageChange}
                                    latitudeChange={latitudeChange}
                                    longitudeChange={longitudeChange}
                                    handleSelectAccessType={handleSelectAccessType}
                                    getSpecificPole={getSpecificPole}
                                    setSpecText={setSpecText}
                                    potentialPoles={potentialPoles}
                                    changePoleOnTicket={changePoleOnTicket}
                                    sortPoles={sortPoles}
                                    setPoleSort={setPoleSort}
                                    sortPoleAsc={sortPoleAsc}
                                    setSortPoleAsc={setSortPoleAsc}
                                    utilsForDropdown={utilsForDropdown}
                                    handleTicketSelectUtility={handleTicketSelectUtility}
                                    job={job}
                                    resetPoleId={resetPoleId}
                                    changePoleId={changePoleId}
                                    changeLineId={changeLineId}
                                    changeDueDate={handleDueDateChange}
                                />

                                <TicketInfo
                                active={selectedTab === 'info'}
                                ticket={ticket}
                                jobNumber={jobNumber}
                                accessTypesForDropdown={props.accessTypesForDropdown}
                                pole={pole}
                                specHintData={specHintData}
                                workingForemenForDropdown={workingForemenForDropdown}
                                handleWorkingForemanChange={handleWorkingForemanChange}
                                specText={specText}
                                changeRadio={changeRadio}
                                handleAmbMeetup={handleAmbMeetup}
                                handleEhasp={handleEhasp}
                                handleDigDrop={handleDigDrop}
                                handleNRADrop={handleNRADrop}
                                handlePermitDrop={handlePermitDrop}
                                handleSelectAccessType={handleSelectAccessType}
                                addPermit={addPermit}
                                changePermitType={changePermitType}
                                updateTicketNote={updateTicketNote}
                                handleDeleteWoChip={handleDeleteWoChip}
                                handleAddWoChip={handleAddWoChip}
                                activeWorkingNote={activeWorkingNote}
                                addNote={addNote}
                                toggleAddNote={toggleAddNote}
                                updateWorkingNote={updateWorkingNote}
                                loadingPermitDnD={loadingPermitDnD}
                                loadingDigSafeDnD={loadingDigSafeDnD}
                                loadingNRADnD={loadingNRADnD}
                                ehasp={ehasp}
                                digsafe={digsafe}
                                nra={nra}
                                permit_0={permit_0}
                                handleFileSelectClick={handleFileSelectClick}
                                handleDigFileSelectClick={handleDigFileSelectClick}
                                handleNraFileSelectClick={handleNraFileSelectClick}
                                handlePermitFileSelectClick={handlePermitFileSelectClick}
                                handleDigSafeFileUpload={handleDigSafeFileUpload}
                                handleNRAFileUpload={handleNRAFileUpload}
                                handlePermitFileUpload={handlePermitFileUpload}
                                removeFile={removeFile}
                                handleImageDeleted={handleImageDeleted}
                                />

                                <TicketTasks
                                    active={selectedTab === 'tasks'}
                                    ticket={ticket}
                                    // jobNumber={jobNumber}   
                                    // serviceTasks={serviceTasks}
                                    updateTicketDescription={updateTicketDescription}
                                    // expandTaskSection={expandTaskSection}
                                    // expandedTaskSections={expandedTaskSections}
                                    // taskChecked={taskChecked}
                                    tasksChanged={tasksChanged}
                                />

                               
                            </div>
                        </div>
                        
                        {/* MODAL FOOTER */}
                        <div className={`modal-footer modalFooter`}>
                            <button 
                                style={{ display: needsMerge || !pole.id ? 'none' : 'block' }}
                                type="button"
                                className={`btn btn-primary modalFooterButton` + (saveEnabled ? ' ' : ' disabled')}
                                onClick={props.saveTicket}
                                disabled={!saveEnabled}
                            >
                                Save
                            </button>
                        </div>  
                    </div>
                </div>
            </div>
        
          
          {/* {activeWorkingNote &&
            <div className={styles.notesModalContain}></div>
          } */}
        </div>
    );
}

export default TicketView;